<template>
    <div class="answerpeople">
        <el-input size="mini" v-model="query.nickname" placeholder="请输入用户昵称"></el-input>
        <el-input size="mini" v-model="query.mobile_phone" placeholder="请输入用户手机号" @input="handleInput"></el-input>
        <el-button size="mini" type="primary" @click="getanswerList">搜索</el-button>
        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
                <el-table-column label="用户昵称" align="center" min-width="2%">
                    <template slot-scope="{ row }">
                        <div>{{ row.nickname }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="手机号" align="center" min-width="5%">
                    <template slot-scope="{ row }">
                        <div>{{ row.mobile_phone }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="提交时间" align="center" min-width="3%">
                    <template slot-scope="{ row }">
                        <div>{{ row.created_at }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="答对题数" align="center" min-width="2%">
                    <template slot-scope="{ row }">
                        <div>{{ row.correct_quantity }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="7%">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="opencompile(row)">查看答卷</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getanswerList" :current-page.sync="query.page" :page-size="query.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog :title="dialogtitle" :visible.sync="centerDialogVisible" width="30%" center v-loading="loading">
            <div class="dialogbox" v-for="(item, index) in form" :key="index">
                <div class="exer_title"> {{ index + 1}}、{{ item.question }}</div>
                <div v-for="value in item.option" :key="value.index" class="options">
                    <div style="">{{ value.value }}</div>
                    <div class="answerinput" style="margin-left:8px" v-if="item.type == 'radio'"><el-radio v-model="value.selected" :label="1" disabled>{{ value.answer }}</el-radio></div>
                    <div class="answerinput" style="margin-left:8px;text-wrap: wrap; width: 100%;" v-else><el-checkbox v-model="value.selected" :label="value.index" disabled>{{ value.answer }}</el-checkbox></div>
                    <div v-if="value.right == 1" style="color: #409eff; margin-left: 20px; margin-left: auto; min-width: 60px;">正确答案</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { answerList, resultInfo } from "@/api/exercises";
export default {
    name: "",
    data() {
        return {
            list: [],
            query: {
                exercise_question_id: this.$route.query.id || "",
                nickname: "",
                mobile_phone: "",
                limit: 20,
                page: 1,
            },
            total: null,
            loading: true,
            centerDialogVisible: false,
            dialogtitle: "",
            form: [],
        };
    },
    components: {},
    computed: {},
    created() {
        this.dialogtitle = this.$route.query.title;
    },
    mounted() {
        this.getanswerList();
    },
    methods: {
        getanswerList() {
            answerList(this.query).then((res) => {
                if (res.code == 1) {
                    this.list = res.data.list;
                    this.total = res.data.total;
                    this.loading = false;
                }
            });
        },
        opencompile(row) {
            this.centerDialogVisible = true;
            this.loading = true;
            this.form = {};
            resultInfo({ result_id: row.id }).then((res) => {
                if (res.code == 1) {
                    this.form = res.data.question;
                    this.form.forEach((item) => {
                        if (item.type == "checkbox") {
                            item.option.forEach((opt) => {
                                opt.selected = opt.selected == 1; // 转换为布尔值
                            });
                        } else if (item.type == "radio") {
                            item.option.forEach((opt) => {
                                if (opt.selected == "1" || opt.selected == 1) {
                                    console.log("111111");
                                    opt.selected = 1;
                                }
                            });
                        }
                        // 如果还有其他需要特殊处理的类型，可以继续添加条件分支
                    });
                    this.loading = false
                }
            });
        },
        handleInput() {
            // 过滤非数字字符
            this.query.mobile_phone = this.query.mobile_phone.replace(
                /\D/g,
                ""
            );
        },
    },
};
</script>

<style >
.answerpeople .el-input {
    width: 200px;
    margin-right: 30px;
}

.answerpeople .block .el-input {
    width: 60px;
}
.dialogbox {
    padding-bottom: 8px;
}
.dialogbox .options {
    display: flex;
    flex-wrap: nowrap;
    padding: 5px;
    /* align-items: center; */
}
.exer_title {
    font-weight: 600;
    margin-bottom: 15px;
}
.answerinput .el-checkbox__label,.answerinput .el-radio__label{
    width: 80%;
    text-wrap: wrap;
}
.answerinput .el-checkbox ,.answerinput .el-radio{
    display: flex;
}
</style>
